module.exports = __webpack_public_path__ + "7fdf302fba09ec693e5d95e25bbb2da4.MP3";